module.exports = __webpack_public_path__ + "static/media/kid-and-pet.b924573f.jpg";